import { NotFoundError } from "@sportactics/errors";
import { createContext } from "react";

import { LazyValue, useLazyContext } from "~utils";

import { User } from "./user";

export function useUserFirestorePersistence(): useUserFirestorePersistenceReturn {
  return useLazyContext(UserFirestorePersistenceContext);
}

export type useUserFirestorePersistenceReturn = {
  upsertUser: (user: FirestorePersistenceUser) => Promise<void>;
  getUser: (id: string) => Promise<FirestorePersistenceUser>;
};

export type FirestorePersistenceUser = Omit<
  User,
  "authenticated" | "name" | "email" | "photoUrl"
>;

export class UserNotFoundError extends NotFoundError {
  constructor(id: string) {
    super("User", id);
    this.name = UserNotFoundError.name;
  }
}

export const UserFirestorePersistenceContext =
  createContext<LazyValue<useUserFirestorePersistenceReturn>>(undefined);
